import { useCallback, useEffect, useState } from 'react'
import { ProjectPlanBreadcrumbs } from '../../../components/navigation/project-plan-breadcrumbs'
import {
  getProjectPlanUuidByWbsItemUuid,
  getWbsItemUuidByProjectPlanUuid,
} from '../../../../lib/functions/projectPlan'
import { WbsItemType } from '../../../../domain/entity/WbsItemEntity'
import { intl } from '../../../../i18n'

// スプリントレポートの root に指定できるのは工程 / ワークグループのみ (WbsItemSelect・右クリック導線と揃える)。
// 「+」で降りる候補もこの 2 タイプに絞り、工程より下 (成果物・タスク) には降りられないようにする。
// module スコープの定数にして参照を固定し、子取得フックの再実行ループを防ぐ。
const ROOT_SELECTABLE_TYPES = [WbsItemType.WORKGROUP, WbsItemType.PROCESS]

type Props = {
  // root 未指定 (undefined) のときはプロジェクトルートのパンくず (プロジェクト名のみ) を表示する。
  rootWbsItemUuid: string | undefined
  onSelectRootWbsItem: (rootWbsItemUuid: string | undefined) => void
}

// Kanban / BurndownChart と同じ navigation パンくずを使い、「+」ボタンで子へ降りる導線を揃える。
// navigation 版は projectPlanUuid で動くが、スプリントレポートの検索条件は wbsItemUuid を保持するため、
// 入力 (wbsItem→projectPlan) と選択時 (projectPlan→wbsItem) の両方向で変換して橋渡しする (KanbanV2 と同方式)。
export const SprintReportBreadcrumb = ({
  rootWbsItemUuid,
  onSelectRootWbsItem,
}: Props) => {
  const [rootProjectPlanUuid, setRootProjectPlanUuid] = useState<
    string | undefined
  >()

  useEffect(() => {
    // root 未指定ならプロジェクトルート表示 (rootProjectPlanUuid=undefined) に戻す。
    if (!rootWbsItemUuid) {
      setRootProjectPlanUuid(undefined)
      return
    }
    getProjectPlanUuidByWbsItemUuid(rootWbsItemUuid).then(
      setRootProjectPlanUuid
    )
  }, [rootWbsItemUuid])

  const onSelectBreadcrumb = useCallback(
    async (projectPlanUuid: string | undefined) => {
      const wbsItemUuid = projectPlanUuid
        ? await getWbsItemUuidByProjectPlanUuid(projectPlanUuid)
        : undefined
      onSelectRootWbsItem(wbsItemUuid)
    },
    [onSelectRootWbsItem]
  )

  return (
    <ProjectPlanBreadcrumbs
      rootProjectPlanUuid={rootProjectPlanUuid}
      onSelectBreadcrumb={onSelectBreadcrumb}
      childTypes={ROOT_SELECTABLE_TYPES}
      noChildrenTooltip={intl.formatMessage({
        id: 'sprintReport.breadcrumb.noChildProcess',
      })}
    />
  )
}
